export default {
    attrsPhisical:[],
    attrsJuridical:[],
    clientPublicType:null,
    typesAnnex: {'required':[], 'not_required':[]},
    maritalStatusesOptions:[],
    naturalPerson:{},
    legalPerson:{},
    address: {
        cep: null,
        street: null,
        number: null,
        neighborhood: null,
        complement: null,
        description: null,
    },
    commercialAddress: {
        cep: null,
        street: null,
        number: null,
        neighborhood: null,
        complement: null,
        description: null,
    },
    spouse:{
        fillMode: 'search',
    },
    responsible: {
        fillMode: 'search',
    },
    anexes:[],
}